import { FieldErrors, FieldValues } from 'react-hook-form/dist/types';

type HasNthErrors = (props: {
    expectedErrors: number;
    formErrors: FieldErrors<FieldValues>;
}) => boolean;

export const hasNthErrors: HasNthErrors = ({ expectedErrors, formErrors }) =>
    Object.entries(formErrors).length === expectedErrors;
